import { useCallback } from 'react'
import ecbrApi from '../../../services/ecbrApi'
import { extractErrorMessage } from '../../../helpers/extractErrorMessage'

export const useValidateCoupon = (
  setDiscountPercentage,
  setError,
  discountPercentage
) => {
  return useCallback(
    async (value) => {
      if (!value) return true
      try {
        const { data } = await ecbrApi.coupons.validateCoupon(value)
        if (data?.success) {
          setDiscountPercentage(Number(data.percentage) / 100)
          setError('')
          return true
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        setError(errorMessage)
      }
      if (discountPercentage !== 0) {
        setDiscountPercentage(0)
      }
      return false
    },
    [discountPercentage, setDiscountPercentage, setError]
  )
}
